<template>
  <div>
    <div
      data-cy="form-label"
      class="b-dialog__top-panel"
    >
      <h2>События по договору</h2>
      <button
        class="b-btn b-btn_border_none"
        @click="closeDeactivationEvent"
      >
        <dynamic-icon icon="close" />
      </button>
    </div>
    <div class="b-full-table">
      <div class="b-full-table__row b-full-table__row-header">
        <div
          class="b-full-table__cell b-full-table__header-cell b-full-table__header-cell_date"
        >
          {{ $t('CONTENT.events.event_date') }}
        </div>
        <div class="b-full-table__cell b-full-table__header-cell b-full-table__header-cell_date">
          {{ $t('CONTENT.events.lat_event_date') }}
        </div>
        <div class="b-full-table__cell b-full-table__header-cell b-full-table__header-cell_type">
          {{ $t('CONTENT.events.event_type') }}
        </div>
        <div class="b-full-table__cell b-full-table__header-cell b-full-table__header-cell_type">
          {{ $t('CONTENT.events.Deactivate') }}
        </div>
        <div class="b-full-table__cell b-full-table__header-cell b-full-table__header-cell_type" />
      </div>
      <template v-for="(version) in convertedEvents">
        <div
          :key="version.idInDB"
          class="b-table__row b-full-table__row"
        >
          <div class="b-full-table__cell b-full-table__cell_event_date">
            {{ version.convertedDate }}
          </div>
          <div class="b-full-table__cell b-full-table__cell_event_date">
            {{ version.convertedCreatedDate }}
          </div>
          <div class="b-full-table__cell b-full-table__cell_event_type">
            {{ version.translatedEventType }}
            <br>
            <div
              v-if="version.isIntegrationEvent"
              class="mt-1 ml-2"
            >
              <span class="b-full-table__annotation">{{ $t('CONTENT.events.version_annotation') }}</span>
            </div>
          </div>
          <div class="b-full-table__cell b-full-table__cell_type_btn">
            <div>
              <checkbox
                v-if="version.eventType !== 'initial_recognition'"
                :id="version.id"
                :model="version.isActive"
                :name="'versionCheckbox'"
                :value="version.id"
                :disabled="false"
                :color="'#de301e'"
                :size="22"
                @change="updateSelectedEvents(version)"
              />
            </div>
          </div>
        </div>
      </template>
    </div>
    <confirmation-modal ref="confirmationModal" />
    <div class="col-12">
      <div class="b-form__container b-form__container_type_flex b-form__container_type_flex_end">
        <button
          data-cy="save-button"
          class="b-btn b-btn_type_primary"
          type="submit"
          :disabled="isDisabledDeactivateBtn"
          @click="deactivateSelectedEvents"
        >
          {{ $t('CONTENT.events.Deactivate') }}
        </button>
        <button
          class="b-btn b-btn_type_empty m-2"
          @click.prevent="closeDeactivationEvent"
        >
          {{ $t('CONTENT.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import lodash from 'lodash';
import { mapGetters } from 'vuex';
import dateConverter from '@/utils/converters/date.converter';
import ContractEventsMixin from '@/plugins/eventRegistry/components/widget/ContractEventsMixin.vue';
import DeactivateEvent from '@/plugins/eventRegistry/models/commands/DeactivateEvent';

export default {
  mixins: [ContractEventsMixin],
  data() {
    return {
      events: null,
      localStoragePrefix: 'contract_versions_',
      selectedEvents: [],
      isDisabledDeactivateBtn: true,
    };
  },
  computed: {
    ...mapGetters(['getAssets', 'getContractAssetComponents', 'getContractSettings']),
    convertedEvents() {
      const { lastClosePeriodDate } = this.getContractSettings;
      const convertedLastClosePeriodDate = new Date(dateConverter.convertToDate(lastClosePeriodDate));
      this.events = this.$store.state.eventRegistryPlugin.directoryEvents;
      const convertedArray = [];
      for (let i = 0; i < this.events.length; i++) {
        const element = this.events[i];
        const clone = lodash.clone(element);
        if (!(clone.eventType !== 'initial_recognition' && new Date(dateConverter.convertToDate(clone.createEventDate) < convertedLastClosePeriodDate))) continue;
        clone.convertedDate = this.$d(dateConverter.convertToDate(clone.eventDate));
        if (clone.createEventDate) {
          clone.convertedCreatedDate = this.$d(dateConverter.convertToDate(clone.createEventDate));
        }
        clone.isCurrent = this.$route.query.eventId == clone.idInDB;
        clone.translatedEventType = this.$t(`CONTENT.events.${clone.eventType}`);
        clone.isActive = false;
        convertedArray.push(clone);
      }
      return convertedArray;
    },
  },
  methods: {
    updateSelectedEvents(version) {
      const sortedEvents = this.convertedEvents;
      const selectedVersionIndex = sortedEvents.indexOf(version);
      if (sortedEvents.filter(x => x.isActive).length === 0) {
        for (let i = selectedVersionIndex; i < sortedEvents.length; i++) {
          sortedEvents[i].isActive = true;
        }
      } else {
        const newState = !sortedEvents[selectedVersionIndex].isActive;
        for (let i = selectedVersionIndex; i >= 0; i--) {
          sortedEvents[i].isActive = newState;
        }
      }
      this.selectedEvents = sortedEvents.filter(x => x.isActive);
      this.isDisabledDeactivateBtn = !(this.selectedEvents.length > 0);
    },
    deactivateSelectedEvents() {
      const command = new DeactivateEvent(this.selectedEvents.map(event => event.idInDB));
      this.$store.commit('eventRegistryPlugin/addOrUpdateCommand', command);
      this.$store.commit('eventRegistryPlugin/toggleModalToFormDirectoryEvent', this.convertedEvents[0].contractId);
      this.$emit('close');
    },
    closeDeactivationEvent() {
      this.$store.commit('eventRegistryPlugin/deleteAllCommands');
      this.$emit('close');
    },
    onException(e) {
      let message = this.$t('ERRORS.UnknownError');

      if (e.response === undefined) {
        message = this.$t('ERRORS.NetworkError');
      } else {
        const { status } = e.response;
        if (status === 400) message = e.response.data.exceptions[0].message;
        if (status === 500) message = this.$t('ERRORS.SystemError');
      }
      this.$toast.error(message);
    },
  },
};
</script>

<style scoped>
.external-id {
  color: #7d7d7d;
}
</style>
